import * as React from 'react';

type Props = {
    children: React.ReactNode;
};

/*
 * This is an SVG of a three-stage pipeline.
 */
export function Pipeline({children}: Props) {
    return (
        <svg viewBox='0 0 350 147' xmlns='http://www.w3.org/2000/svg'>
            <defs>
                <filter
                    x='-6%'
                    y='-16.7%'
                    width='112%'
                    height='133.3%'
                    filterUnits='objectBoundingBox'
                    id='filter-1'
                >
                    <feGaussianBlur stdDeviation='2' in='SourceGraphic' />
                </filter>
            </defs>
            <g id='Page-1' fill='none' fillRule='evenodd'>
                <g id='pipeline'>
                    <g id='stage1'>
                        <path
                            d='M2.297 0h108.687c.35 0 .668.242.824.625l6.922 16.956c.13.32.13.694 0 1.013l-6.922 16.957c-.156.383-.475.624-.824.624H2.297c-.32 0-.616-.203-.784-.536a1.355 1.355 0 0 1-.04-1.1l6.508-15.945c.13-.319.13-.694 0-1.012L1.474 1.637a1.355 1.355 0 0 1 .04-1.1C1.68.203 1.977 0 2.296 0z'
                            id='chevron'
                            fill='#FFF'
                            fillRule='nonzero'
                        />
                        <rect
                            id='column'
                            fill='#FFF'
                            fillRule='nonzero'
                            opacity='.4'
                            x='.651'
                            y='40.126'
                            width='111.434'
                            height='106'
                            rx='3.403'
                        />
                        <text id='Qualify' fontFamily='IBM Plex Sans' fontSize='16' fill='#4A4A4A'>
                            <tspan x='16.509' y='25.561'>
                                Qualify
                            </tspan>
                        </text>
                    </g>
                    <g id='stage2' transform='translate(115)'>
                        <path
                            d='M2.297 0h108.687c.35 0 .668.242.824.625l6.922 16.956c.13.32.13.694 0 1.013l-6.922 16.957c-.156.383-.475.624-.824.624H2.297c-.32 0-.616-.203-.784-.536a1.355 1.355 0 0 1-.04-1.1l6.508-15.945c.13-.319.13-.694 0-1.012L1.474 1.637a1.355 1.355 0 0 1 .04-1.1C1.68.203 1.977 0 2.296 0z'
                            id='chevron'
                            fill='#FFF'
                            fillRule='nonzero'
                        />
                        <rect
                            id='column'
                            fill='#FFF'
                            fillRule='nonzero'
                            opacity='.4'
                            x='.651'
                            y='40.126'
                            width='111.434'
                            height='106'
                            rx='3.403'
                        />
                        <text id='Pitch' fontFamily='IBM Plex Sans' fontSize='16' fill='#4A4A4A'>
                            <tspan x='15.257' y='25.561'>
                                Pitch
                            </tspan>
                        </text>
                    </g>
                    <g id='stage3' transform='translate(231)'>
                        <path
                            d='M2.297 0h108.687c.35 0 .668.242.824.625l6.922 16.956c.13.32.13.694 0 1.013l-6.922 16.957c-.156.383-.475.624-.824.624H2.297c-.32 0-.616-.203-.784-.536a1.355 1.355 0 0 1-.04-1.1l6.508-15.945c.13-.319.13-.694 0-1.012L1.474 1.637a1.355 1.355 0 0 1 .04-1.1C1.68.203 1.977 0 2.296 0z'
                            id='chevron'
                            fill='#FFF'
                            fillRule='nonzero'
                        />
                        <rect
                            id='column'
                            fill='#FFF'
                            fillRule='nonzero'
                            opacity='.4'
                            x='.651'
                            y='40.126'
                            width='111.434'
                            height='106'
                            rx='3.403'
                        />
                        <text id='Close' fontFamily='IBM Plex Sans' fontSize='16' fill='#4A4A4A'>
                            <tspan x='16.473' y='25.561'>
                                Close
                            </tspan>
                        </text>
                    </g>
                    {children}
                </g>
            </g>
        </svg>
    );
}
